export var ISSUE_NAVIGATOR_URL = "/issues/?jql=".concat(encodeURIComponent('created >= -30d order by created DESC'));